import CryptoJS from 'crypto-js';
import constants from '../constants';

let { ENCRYPTION_KEY, dataIVKey } = constants;

export function setSiteSettingsKey(key) {
  ENCRYPTION_KEY = key;
}

export function decrypt(text) {
  const textParts = text.split('---');
  const iv = CryptoJS.enc.Base64.parse(textParts[1]);
  const encryptedText = CryptoJS.enc.Base64.parse(textParts[0]);
  
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: encryptedText },
    CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY),
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  
  const strData = decrypted.toString(CryptoJS.enc.Utf8);
  return JSON.parse(strData);
}

function encrypt(data, encryptKEY) {
  const iv = CryptoJS.enc.Utf8.parse(dataIVKey);
  const strData = JSON.stringify(data);
  const key = CryptoJS.enc.Utf8.parse(encryptKEY);
  
  const encrypted = CryptoJS.AES.encrypt(strData, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  
  const encryptedText = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  const ivtext = CryptoJS.enc.Base64.stringify(iv);
  return `${encryptedText}---${ivtext}`;
}

export function getAES(data) {
  const encrypted = encrypt(data, ENCRYPTION_KEY);
  return encrypted;
}
